
// src/components/Unauthorized.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Unauthorized = () => {
    const { user } = useSelector(state => state.auth);

    return (
        <div className="error-page">
            <div className="error-code">403</div>
            <h1>Access Denied</h1>
            <p>
                Sorry, you don't have permission to access this page.
                {user?.role && (
                    <span> Your current role is <strong>{user.role}</strong>.</span>
                )}
            </p>
            <Link to="/dashboard" className="btn btn-primary">
                Back to Dashboard
            </Link>
        </div>
    );
};

export default Unauthorized;